import trash from "../images/icons/delete_icon.svg";
import "../styles/sipCart.css";
import { Link } from "react-router-dom";
import SelectDropDown from "./SelectDropDown";
import { useDispatch, useSelector } from "react-redux";
import { Field, FieldArray } from "formik";
import { DeleteMyCart } from "../actions/exploreFundsActions";
import { getLocalStorageUserData } from "../utils/userData";
import PopupModel from "./PopupModel";
import successlogo from "../images/popup/success-popup.svg";
import cancel from "../images/popup/alert-image.svg";
import "../styles/profile.css";
import "../styles/popup-custom.css";
import { useState } from "react";
import defaultFundIcon from "../images/Default icon.svg";
import { exploreSipData } from "../actions/cardAction";
import DatePickerInput from "./DatePickerInput";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CreatableSelect from "react-select/creatable";
import moment from "moment";
import calendarImage from "../images/calendar_month.svg";
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: state.isDisabled ? "#D1D1D1" : "#FFFFFF",
    borderColor: state.isDisabled ? "#C0C3C9" : provided.borderColor,
    "&:hover": {
      borderColor: state.isDisabled ? "#C0C3C9" : provided.borderColor,
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? "#6c757d" : provided.color, 
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? "#6c757d" : provided.placeholder,
  }),
};

const SipAndLumpsumCart = (props) => {
  const dispatch = useDispatch();
  const { addToCardData } = useSelector((state) => state.myCard);
  const userData = getLocalStorageUserData();
  const [isPopupVisible, setIsPopupVisible] = useState(false); // Manage popup visibility
  const [cartId, setCartId] = useState("");

  // const [frequency, setFrequency] = useState("");
  const closeModal = () => {
    setIsPopupVisible(false);
  };

  const actionPopup = () => {
    dispatch(DeleteMyCart(cartId, 1));
  };

  const getSipData = (scheme_code, sip_frequency, index) => {
    const payload = {
      scheme_code: scheme_code,
      sip_frequency: sip_frequency,
    };
    dispatch(exploreSipData(payload)).then((res) => {
      props?.setSipDataMap((prev) => ({
        ...prev,
        [index]: res.data, // or use scheme_code as key if that makes more sense
      }));
    });
  };

  return (
    <>
      {props?.values?.length > 0 ? (
        props?.values?.map((result, index) => {
          return (
            <>
              <div
                className="card Sip-card overflow-hiddden bg-white mt-3"
                key={index}
              >
                <div className="card-body p-0">
                  {" "}
                  <div className="fund-details-info d-flex flex-wrap align-items-center gap-3">
                    <img
                      src={
                        result?.cart_product?.master_scheme?.fund_icon?.icon
                          ? `${process.env.REACT_APP_FUND_ICON_URL}/logos/${result?.cart_product?.master_scheme?.fund_icon?.icon}.png`
                          : defaultFundIcon
                      }
                      alt="Fund Logo"
                      className="fund-logo me-3 mb-sm-0 mb-2"
                      onError={(e) => {
                        e.target.onerror = null; // Prevents infinite loop if default image fails
                        e.target.src = defaultFundIcon;
                      }}
                    />
                    <div>
                      {/* <Link to={`/explore/fund-detail`}> */}
                      <h6 className="fund-name">
                        {result?.cart_product?.master_scheme?.scheme_name}
                      </h6>
                      {/* </Link> */}
                      <div className="d-flex flex-wrap gap-2"></div>
                    </div>
                    <div className="ms-lg-auto mt-sm-0 mt-0 d-flex align-items-center">
                      <div className="right-toggle-section">
                        <div className="toggle-group">
                          <label className="toggle-option">
                            <input
                              type="radio"
                              value="S"
                              checked={result?.investment_mode === "S"}
                              name={`prducts_in_cart[${index}].investment_mode`}
                              onChange={() => {
                                // props?.resetForm();

                                props.setFieldValue(
                                  `products_in_cart[${index}].amount`,
                                  addToCardData?.data?.products_in_cart?.[index]
                                    ?.minimum_amount
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].step_up_required`,
                                  false
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].date_installment`,
                                  ""
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].frequency_type`,
                                  ""
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].installment_no`,
                                  ""
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].step_up_amount`,
                                  ""
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].step_up_frequency`,
                                  ""
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].step_up_amount`,
                                  ""
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].investment_mode`,
                                  "S"
                                );
                              }}
                            />
                            SIP
                          </label>
                          <label className="toggle-option">
                            <input
                              type="radio"
                              value="N"
                              checked={result?.investment_mode === "N"}
                              name={`products_in_cart[${index}].investment_mode`}
                              onChange={() => {
                                // props?.resetForm();
                                props.setFieldValue(
                                  `products_in_cart[${index}].amount`,
                                  addToCardData?.data?.products_in_cart?.[index]
                                    ?.lumpsumProductlimit?.minimum_amount
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].step_up_required`,
                                  false
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].date_installment`,
                                  ""
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].frequency_type`,
                                  ""
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].installment_no`,
                                  ""
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].step_up_amount`,
                                  ""
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].step_up_frequency`,
                                  ""
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].final_amt`,
                                  ""
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].investment_mode`,
                                  "N"
                                );
                              }}
                            />
                            Lumpsum
                          </label>
                        </div>
                        {/* start setp up code comment beacuse of client side pending we need api from nsc and backend side pending that's why */}
                        {/* <div className="divider_toggle"></div>
                        <div className="step-up-toggle">
                          <label className="toggle-option"> Step Up? </label>
                          <div className="form-check form-switch ms-2">
                            <input
                              className="form-check-input shadow-none switch_mode"
                              type="checkbox"
                              id="flexSwitchCheckDefault"
                              checked={result?.stepup ? true : false}
                              onChange={() => {
                                props?.setFieldValue(
                                  `products_in_cart[${index}].stepup`,
                                  !result?.stepup
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].step_amt`,
                                  ""
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].step_frequency`,
                                  ""
                                );
                                props?.setFieldValue(
                                  `products_in_cart[${index}].final_amt`,
                                  ""
                                );
                              }}
                              disabled={
                                result?.invest_type === "lumpsum" ? true : false
                              }
                            />
                          </div>
                        </div> */}
                        {/* end setp up code comment beacuse of client side pending we need api from nsc and backend side pending that's why */}
                      </div>
                    </div>
                  </div>
                  {/* Input Fields */}
                  <div className=" mt-3">
                    <div className="investment-inputs d-flex gap-3">
                      <div className="input_group">
                        <label for="folio" className="form-lable">
                          Folio No.
                        </label>
                        <SelectDropDown
                          id="folio"
                          name={`products_in_cart[${index}].folionumber`}
                          value={result?.folionumber}
                          changeFunction={(value) =>
                            props?.setFieldValue(
                              `products_in_cart[${index}].folionumber`,
                              value
                            )
                          }
                          // setFrequency={setFrequency}
                          // getSipData={getSipData()}
                          schemacode={result?.cart_product?.scheme_code}
                          options={Object.keys(result?.folio).map((key) => ({
                            value: key,
                            label: key,
                          }))}
                        // options={result?.folioList?.map((folio) => ({
                        //   value: folio,
                        //   label: folio,
                        // }))}
                        />
                        {props?.formik.errors?.products_in_cart?.[index]
                          ?.folionumber ? (
                          <div className="text-danger">
                            {
                              props?.formik.errors.products_in_cart?.[index]
                                ?.folionumber
                            }
                          </div>
                        ) : null}
                      </div>
                      {/* <div className="input_group">
                        <label for="folio" className="form-lable">
                          Scheme <span className="text-danger">*</span>
                        </label>
                        <SelectDropDown
                          id="reinvest"
                          name={`products_in_cart[${index}].reinvest`}
                          value={result?.reinvest}
                          changeFunction={(value) => {
                            props?.setFieldValue(
                              `products_in_cart[${index}].reinvest`,
                              value
                            );
                          }}
                          options={
                            result?.cart_product?.product?.reinvest_tag == "Z"
                              ? [
                                  {
                                    value: "Z",
                                    label: "Growth",
                                  },
                                ]
                              : result?.sreinvest == "N"
                              ? [
                                  {
                                    value: "N",
                                    label: "Dividend Payout",
                                  },
                                ]
                              : result?.cart_product?.product?.reinvest_tag ==
                                "Y"
                              ? [
                                  {
                                    value: "Y",
                                    label: "Dividend Reinvest",
                                  },
                                ]
                              : result?.cart_product?.product?.reinvest_tag ==
                                "X"
                              ? [
                                  {
                                    value: "Y",
                                    label: "Dividend Reinvest",
                                  },
                                  {
                                    value: "N",
                                    label: "Dividend Payout",
                                  },
                                ]
                              : []
                          }
                          // options={result?.folioList?.map((folio) => ({
                          //   value: folio,
                          //   label: folio,
                          // }))}
                        />
                        {props?.formik.errors?.products_in_cart?.[index]
                          ?.reinvest ? (
                          <div className="text-danger">
                            {
                              props?.formik.errors.products_in_cart?.[index]
                                ?.reinvest
                            }
                          </div>
                        ) : null}
                      </div> */}

                      <div className="input_group">
                        <label className="form-lable">
                          Frequency{" "}
                          {result?.investment_mode === "S" ? (
                            <span className="text-danger">*</span>
                          ) : (
                            ""
                          )}
                        </label>
                        <SelectDropDown
                          name={`products_in_cart[${index}].frequency_type`}
                          id="frequency_type"
                          value={result?.frequency_type}
                          changeFunction={(value) => {
                            if (value === "DAILY") {
                              props?.setFieldValue(
                                `products_in_cart[${index}].until_cancel`,
                                0
                              );
                            }
                            props?.setFieldValue(
                              `products_in_cart[${index}].frequency_type`,
                              value
                            );
                            getSipData(
                              result?.cart_product?.scheme_code,
                              value,
                              index
                            );
                          }}
                          options={
                            result?.frequencies &&
                            Object.keys(result?.frequencies).map((key) => ({
                              value: result?.frequencies[key],
                              label: result?.frequencies[key],
                            }))
                          }
                          disabled={
                            result?.investment_mode == "N" ? true : false
                          }
                        />
                        {props?.formik.errors?.products_in_cart?.[index]
                          ?.frequency_type ? (
                          <div className="text-danger">
                            {
                              props?.formik.errors.products_in_cart?.[index]
                                ?.frequency_type
                            }
                          </div>
                        ) : null}
                      </div>
                      <div className="input_group">
                        <label className="form-lable">
                          Amount <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name={`products_in_cart[${index}].amount`}
                          value={result?.amount || ""}
                          onChange={props?.handleChange}
                        />
                        {props?.formik.errors?.products_in_cart?.[index]
                          ?.amount ? (
                          <div className="text-danger">
                            {
                              props?.formik.errors.products_in_cart?.[index]
                                ?.amount
                            }
                          </div>
                        ) : null}
                      </div>
                      <div className="input_group">
                        <label for="date_installment" className="form-lable">
                          Start Date{" "}
                          {result?.investment_mode === "S" ? (
                            <span className="text-danger">*</span>
                          ) : (
                            ""
                          )}
                        </label>
                        <div className="datepicker-wrapper  ">
                          <DatePicker
                            className="date_birth_input form-control"
                            selected={
                              result?.date_installment &&
                                moment(
                                  result.date_installment,
                                  "DD/MM/YYYY",
                                  true
                                ).isValid()
                                ? moment(
                                  result.date_installment,
                                  "DD/MM/YYYY"
                                ).toDate()
                                : null
                            }
                            onChange={(date) => {
                              if (!date || !moment(date).isValid()) return;

                              const formattedDate =
                                moment(date).format("DD/MM/YYYY");
                              props.setFieldValue(
                                `products_in_cart[${index}].date_installment`,
                                formattedDate
                              );
                            }}
                            filterDate={(date) => {
                              const today = new Date();
                              today.setHours(0, 0, 0, 0);
                              const selectedDate = new Date(date);
                              selectedDate.setHours(0, 0, 0, 0);

                              const day = selectedDate.getDate();

                              return (
                                selectedDate >= today &&
                                props?.sipDataMap?.[index]?.[0]?.sip_dates_array
                                  ?.map(Number)
                                  .includes(day)
                              );
                            }}
                            disabled={result?.investment_mode === "N"}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            dateFormat="dd-MM-yyyy"
                            customInput={
                              <input
                                className="date_birth_input form-control"
                                readOnly
                              />
                            }
                          />
                          {/* Calendar Icon Inside the Input */}
                          {/* <span
    className="calendar-icon"
    onClick={() =>
      document.querySelectorAll(".date_birth_input")[index]?.focus()
    }
    style={{
      position: "absolute",
      top: "50%",
      right: "12px",
      transform: "translateY(-50%)",
      cursor: "pointer",
      zIndex: 10,
    }}
  >
    <img src={calendarImage} alt="Calendar Icon" width={18} height={18} />
  </span> */}
                        </div>
                        {/* <SelectDropDown
                          name={`products_in_cart[${index}].date_installment`}
                          id="date_installment"
                          value={result?.date_installment}
                          changeFunction={(value) =>
                            props?.setFieldValue(
                              `products_in_cart[${index}].date_installment`,
                              value
                            )
                          }
                          options={
                            props?.sipDataMap?.[index]?.[0]?.sip_dates_array?.map(
                              (date) => ({
                                value: date,
                                label: date,
                              })
                            ) || []
                          }
                          disabled={
                            result?.investment_mode == "N" ? true : false
                          }
                        /> */}
                        {props?.formik.errors?.products_in_cart?.[index]
                          ?.date_installment ? (
                          <div className="text-danger">
                            {
                              props?.formik.errors.products_in_cart?.[index]
                                ?.date_installment
                            }
                          </div>
                        ) : null}
                      </div>
                      {result?.investment_mode === "S" && (
                        <div
                          className="form-check form-check-inline"
                          style={{ paddingTop: "30px" }}
                        >
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`first_order_today_${index}`}
                            name={`products_in_cart[${index}].first_order_today`}
                            checked={result?.first_order_today === "Y"}
                            onChange={(e) =>
                              props.setFieldValue(
                                `products_in_cart[${index}].first_order_today`,
                                e.target.checked ? "Y" : "N"
                              )
                            }
                          />
                          <label
                            className="form-check-label ms-2"
                            htmlFor={`first_order_today_${index}`}
                          >
                            First Order Today
                          </label>
                        </div>
                      )}

                      <div className="input_group">
                        <label for="date_installment" className="form-lable">
                          End Date{" "}
                          {result?.investment_mode === "S" ? (
                            <span className="text-danger">*</span>
                          ) : (
                            ""
                          )}
                        </label>

                        <div className="datepicker-wrapper  ">
                          <DatePicker
                            className="date_birth_input form-control"
                            selected={
                              result?.end_date &&
                                moment(
                                  result.end_date,
                                  "DD/MM/YYYY",
                                  true
                                ).isValid()
                                ? moment(result.end_date, "DD/MM/YYYY").toDate()
                                : null
                            }
                            onChange={(date) => {
                              if (!date || !moment(date).isValid()) return;

                              const formattedDate =
                                moment(date).format("DD/MM/YYYY");
                              props.setFieldValue(
                                `products_in_cart[${index}].end_date`,
                                formattedDate
                              );
                            }}
                            filterDate={(date) => {
                              const startDateStr = result?.date_installment;
                              const minInstallments = Number(
                                props?.sipDataMap?.[index]?.[0]
                                  ?.sip_minimum_installment_numbers || 0
                              );
                              const maxInstallments = Number(
                                props?.sipDataMap?.[index]?.[0]
                                  ?.sip_maximum_installment_numbers || 999
                              );

                              if (!startDateStr) return false;

                              const startDate = moment(
                                startDateStr,
                                "DD/MM/YYYY"
                              ).startOf("day");

                              const minEndDate = moment(startDate)
                                .add(minInstallments - 1, "days")
                                .startOf("day");
                              const maxEndDate = moment(startDate)
                                .add(maxInstallments - 1, "days")
                                .startOf("day");

                              const selectedDate = moment(date).startOf("day");
                              console.log("minEndDate", minEndDate, maxEndDate);
                              return (
                                selectedDate.isSameOrAfter(minEndDate) &&
                                selectedDate.isSameOrBefore(maxEndDate)
                              );
                            }}
                            placeholderText="DD/MM/YYYY"
                            dateFormat="dd/MM/yyyy"
                            disabled={
                              result?.investment_mode === "N" || // Lumpsum
                              result?.frequency_type !== "DAILY" || // Only DAILY should be enabled
                              result?.until_cancel === 1 // Until Cancel flag
                            }
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            customInput={
                              <input
                                className="date_birth_input form-control"
                                readOnly
                              />
                            }
                          />

                          {/* Calendar Icon Inside the Input */}
                          {/* <span
    className="calendar-icon"
    onClick={() =>
      document.querySelectorAll(".date_birth_input")[index]?.focus()
    }
    style={{
      position: "absolute",
      top: "50%",
      right: "12px",
      transform: "translateY(-50%)",
      cursor: "pointer",
      zIndex: 10,
    }}
  >
    <img src={calendarImage} alt="Calendar Icon" width={18} height={18} />
  </span> */}
                        </div>
                        {/* <SelectDropDown
                          name={`products_in_cart[${index}].date_installment`}
                          id="date_installment"
                          value={result?.date_installment}
                          changeFunction={(value) =>
                            props?.setFieldValue(
                              `products_in_cart[${index}].date_installment`,
                              value
                            )
                          }
                          options={
                            props?.sipDataMap?.[index]?.[0]?.sip_dates_array?.map(
                              (date) => ({
                                value: date,
                                label: date,
                              })
                            ) || []
                          }
                          disabled={
                            result?.investment_mode == "N" ? true : false
                          }
                        /> */}
                        {props?.formik.errors?.products_in_cart?.[index]
                          ?.end_date ? (
                          <div className="text-danger">
                            {
                              props?.formik.errors.products_in_cart?.[index]
                                ?.end_date
                            }
                          </div>
                        ) : null}
                      </div>

                      {/* <div className="input_group">
                        <label className="form-lable">
                          No. of Installments
                          {result?.invest_type === "sip" ? (
                            <span className="text-danger">*</span>
                          ) : (
                            ""
                          )}
                        </label>
                       
                        <SelectDropDown
                          name={`products_in_cart[${index}].installment_no`}
                          id="installment_no"
                          value={result?.installment_no}
                          changeFunction={(value) => {
                            props?.setFieldValue(
                              `products_in_cart[${index}].installment_no`,
                              value
                            );
                            // props?.setFieldValue(
                            //   `products_in_cart[${index}].until_cancel`,
                            //   0
                            // );
                          }}
                          options={
                            props?.sipDataMap?.[index]?.[0]?.tenure?.map(
                              (tenure) => ({
                                value: tenure,
                                label: tenure,
                              })
                            ) || []
                          }
                          // disabled={
                          //   result?.investment_mode == "N" ||
                          //   result?.frequency_type == "DAILY"
                          //     ? true
                          //     : result?.until_cancel == 1
                          //     ? true
                          //     : false
                          // }
                        />
                        {result?.installment_no ? (
                          result?.installment_no == "Select" ? (
                            <div className="text-danger">
                              {"No of Installment is required"}
                            </div>
                          ) : null
                        ) : props?.formik.errors?.products_in_cart?.[index]
                            ?.installment_no ? (
                          <div className="text-danger">
                            {
                              props?.formik.errors.products_in_cart?.[index]
                                ?.installment_no
                            }
                          </div>
                        ) : null}
                      </div> */}


                      <div className="input_group">
                        <label className="form-lable">
                          No. of Installments
                          {result?.investment_mode === "S" && result?.until_cancel != 1 ? (
                            <span className="text-danger">*</span>
                          ) : (
                            ""
                          )}
                        </label>

                        <CreatableSelect
                          value={
                            result?.installment_no
                              ? { value: result.installment_no, label: result.installment_no }
                              : null
                          }
                          isDisabled={
                            result?.investment_mode === "N" ||
                            result?.until_cancel == 1
                          }
                          styles={customStyles}
                          onChange={(option) => {
                            props.setFieldValue(
                              `products_in_cart[${index}].installment_no`,
                              option?.value
                            );
                          }}
                          options={
                            props?.sipDataMap?.[index]?.[0]?.tenure?.map((tenure) => ({
                              value: tenure,
                              label: tenure,
                            })) || []
                          }
                          placeholder="No. of Installments"
                        />
                        {props?.formik.touched?.products_in_cart?.[index]?.installment_no &&
                          props?.formik.errors?.products_in_cart?.[index]?.installment_no && (
                            <div className="text-danger">
                              {props.formik.errors.products_in_cart[index].installment_no}
                            </div>
                          )}
                      </div>



                      <div
                        className="form-check form-check-inline"
                        style={{ paddingTop: "30px" }}
                      >
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="until_cancelled"
                          name={`products_in_cart[${index}].until_cancel`}
                          disabled={
                            result?.investment_mode == "N"
                              ? true
                              : result?.frequency_type === "DAILY" ? true : result?.end_date == "" ||
                                result?.end_date == undefined
                                ? false
                                : true
                          }
                          // value={result?.until_cancel == 0 ? false : true || ""}
                          checked={result?.until_cancel == 1}
                          onChange={(e) => {
                            if (e.target.checked == true) {
                              props?.setFieldValue(
                                `products_in_cart[${index}].until_cancel`,
                                1
                              );
                              props?.setFieldValue(
                                `products_in_cart[${index}].installment_no`,
                                ""
                              );
                              // formik.setFieldValue("until_cancelled", "Y");
                            } else {
                              props?.setFieldValue(
                                `products_in_cart[${index}].until_cancel`,
                                0
                              );
                              // formik.setFieldValue("until_cancelled", "N");
                            }
                          }}
                        />
                        <label className="form-check-label ms-2" htmlFor="male">
                          Until Cancelled
                        </label>
                        {/* {formik.touched.until_cancelled &&
                          formik.errors.until_cancelled && (
                            <small className="text-danger">
                              {formik.errors.until_cancelled}
                            </small>
                          )} */}
                      </div>
                      {/* start setp up code comment beacuse of client side pending we need api from nsc and backend side pending that's why */}
                      {/* <div className="input_group">
                        <label className="form-lable">Step-Up Amount</label>
                        <input
                          type="number"
                          name={`products_in_cart[${index}].step_amt`}
                          className="form-control"
                          placeholder="Enter"
                          value={result?.step_amt || ""}
                          disabled={
                            result?.invest_type == "lumpsum"
                              ? true
                              : result?.invest_type == "sip" &&
                                result?.stepup == true
                              ? false
                              : true
                          }
                          onChange={props?.handleChange}
                        />
                        {props?.formik.errors?.products_in_cart?.[index]
                          ?.step_amt ? (
                          <div className="text-danger">
                            {
                              props?.formik.errors.products_in_cart?.[index]
                                ?.step_amt
                            }
                          </div>
                        ) : null}
                      </div>
                      <div className="input_group">
                        <label className="form-lable">Step-Up Frequency</label>
                        <SelectDropDown
                          name={`products_in_cart[${index}].step_frequency`}
                          id="step_frequency"
                          value={result?.step_frequency}
                          changeFunction={(value) =>
                            props?.setFieldValue(
                              `products_in_cart[${index}].step_frequency`,
                              value
                            )
                          }
                          disabled={
                            result?.invest_type == "lumpsum"
                              ? true
                              : result?.invest_type == "sip" &&
                                result?.stepup == true
                              ? false
                              : true
                          }
                          options={[
                            {
                              label: "Monthly",
                              value: "M",
                            },
                            {
                              label: "Yearly",
                              value: "Y",
                            },
                          ]}
                        />
                        {props?.formik.errors?.products_in_cart?.[index]
                          ?.step_frequency ? (
                          <div className="text-danger">
                            {
                              props?.formik.errors.products_in_cart?.[index]
                                ?.step_frequency
                            }
                          </div>
                        ) : null}
                      </div>
                      <div className="input_group">
                        <label className="form-lable">Final Amount</label>
                        <input
                          type="number"
                          name={`products_in_cart[${index}].final_amt`}
                          className="form-control"
                          placeholder="Enter"
                          disabled={
                            result?.invest_type == "lumpsum"
                              ? true
                              : result?.invest_type == "sip" &&
                                result?.stepup == true
                              ? false
                              : true
                          }
                          value={result?.final_amt || ""}
                          onChange={props?.handleChange}
                        />
                        {props?.formik.errors?.products_in_cart?.[index]
                          ?.final_amt ? (
                          <div className="text-danger">
                            {
                              props?.formik.errors.products_in_cart?.[index]
                                ?.final_amt
                            }
                          </div>
                        ) : null}
                      </div> */}
                      {/* end setp up code comment beacuse of client side pending we need api from nsc and backend side pending that's why */}
                      <div
                        className="delete-action align-self-end ms-auto"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Delete"
                      >
                        <Link
                          to=""
                          onClick={() => {
                            setCartId(result?.cart_product?.master_scheme_id);
                            setIsPopupVisible(true);
                          }}
                          className="btn_delete ms-3"
                        >
                          <img src={trash} alt="" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        })
      ) : (
        <p>My card not found</p>
      )}

      {isPopupVisible && (
        <PopupModel
          id="alertModel"
          title="Lorem Ipsum"
          content="Are you sure you want to delete this fund?"
          image={cancel}
          closeModal={closeModal}
          btnColor={"btn-danger"}
          actionPopup={actionPopup}
          customClass="cart-custom-popup" // Custom class for styling
          custombodyclass="custom-popup-content" // Custom class for styling
        />
      )}
    </>
  );
};

export default SipAndLumpsumCart;
